import { IconDefinition } from "./types";

const eyeSlash: IconDefinition = {
  iconName: "eye-slash",
  width: 576,
  height: 512,
  svgPathData:
    "M49.3-16.9l-17-17-33.9 33.9 17 17 512 512 17 17 33.9-33.9-17-17-90.4-90.4c53.7-48.2 89.3-109 105.2-148.7-30-74.7-129.6-224-288-224-55.6 0-103.9 18.4-144.5 45.5L49.3-16.9zM178.4 112.2c32.3-19.8 69-32.2 109.8-32.2 63.1 0 116.2 29.5 158.9 70.6 35.6 34.3 61.5 74.5 76.6 105.4-15.1 30.9-41 71.2-76.6 105.4-3.3 3.2-6.7 6.3-10.1 9.3l-42.9-42.9c13.9-20.5 22.1-45.2 22.1-71.9 0-70.7-57.3-128-128-128-26.6 0-51.4 8.1-71.9 22.1l-37.9-37.9zM359.1 292.9L251.2 185c11.1-5.8 23.6-9 36.9-9 44.2 0 80 35.8 80 80 0 13.3-3.3 25.9-9 36.9zM105.8 175.5l-34-34c-35.2 40.4-59.3 83.8-71.7 114.5 30 74.7 129.6 224 288 224 36.8 0 70.5-8.1 100.8-21.4l-37.1-37.1c-20 6.7-41.2 10.5-63.7 10.5-63.1 0-116.2-29.5-158.9-70.6-35.6-34.3-61.5-74.5-76.6-105.4 11.6-23.7 29.5-52.8 53.1-80.5z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "eye-slash",
  unicode: 0xf070,
};

export { eyeSlash };
